<template>
  <div>
    <!--  701无活动报警-->
    <div v-if="indexActive === 27" style="margin: 0 30px;">
      <no-activity :listObj="listObj" :commandObj="commandObj" ref="activity" @getCommandData="getDeviceCommand" @closeOpen="closeOpen"></no-activity>
    </div>
  </div>
</template>

<script>
import {querycommand} from '../../../api/device'
import noActivity from './noActivity.vue'

export default {
  name: 'listTabsDoor',
  components: {noActivity},
  model: {
    prop: 'listShowDoor',
    event: 'change'
  },
  props: {
    listObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      value: '',
      deviceRow: {
        devicetype: 0
      },
      tabs: [],
      indexActive: 27,
      commandObj: {}
    }
  },
  mounted () {
    // 504 508 534 538
    this.deviceRow = this.clone(this.listObj.deviceRow)
    this.getDeviceCommand()
  },
  methods: {
    getDeviceCommand () {
      let data = {
        imei: this.deviceRow.deviceid,
        did: this.deviceRow.id
      }
      querycommand(data).then(res => {
        let resDatas = res.data
        if (resDatas !== null) {
          for (let i = 0; i < resDatas.length; i++) {
            let resData = resDatas[i]
            let key = resData.key
            if (key === 'deviceset') {
            } else {
              let value = JSON.parse(resData.value)
              if (key === 'setisactivity') {
                this.commandObj = value
                this.$refs.activity.getDeviceLocationData(value)
              }
            }
          }
        }
      }).catch(() => {})
    },
    closeOpen () {
      this.$emit('change', false)
    }
  }
}
</script>

<style scoped>
.sos-phone{
  color: #333333;
  font-size: 16px;
  letter-spacing: 1px;
}
.content-info{
  margin: 0 30px;
  height: 400px;
  overflow-y: auto;
  background-color: #FFFFFF;
}

.line-btn{
  height: 60px;
  background: #F2F2F2;
  border-radius: 6px 6px 6px 6px;
  margin: 0px 30px 0;
  display: flex;
}
.btn-name{
  height: 60px;
  line-height: 60px;
  font-weight: 400;
  font-size: 22px;
  color: #1A1A1A;
  letter-spacing: 6px;
  padding: 0 30px;
}
.btn-text{
  height: 60px;
  line-height: 60px;
  font-weight: 400;
  font-size: 22px;
  color: #9FA2AA;
  flex: 1;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: keep-all;
  white-space: nowrap;
}
.btn-arrow{
  width: 100px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}

.clock-item{
  height: 80px;
  font-size: 34px;
  color: #1A1A1A;
  display: flex;
  margin: 30px 30px 0;
}
.clock-type{
  width: 40px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  color: #FFFFFF;
  font-size: 32px;
  border-radius: 6px;
}
.clock-type1{
  background: #6591FC;
}
.clock-type2{
  background: #FFA41D;
}
.lock-val{
  flex: 1;
  margin-left: 30px;
}
.clock-top{
  height: 50px;
  font-size: 34px;
  color: #1A1A1A;
}
.clock-time{
  height: 30px;
  font-size: 24px;
  color: #6A6A6A;
}
.clock-edit{
  width: 70px;
  height: 80px;
  line-height: 80px;
  color: #4578F6;
  font-size: 34px;
}
.clock-del{
  width: 70px;
  height: 80px;
  line-height: 80px;
  color: #ab3939;
  font-size: 34px;
}

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/deviceComponents/listTabsDoor.vue